import React from "react";
import { motion } from "framer-motion";
import { foodItemsStatic } from "../../../types";
import { getToastTabUrl, TOAST_TAB_BASE_URL } from "../../utils/toastTabLinks";

const StaticsImages: React.FC<foodItemsStatic> = ({ items }) => {
  const handleOrderClick = (itemTitle: string) => {
    const toastTabUrl = getToastTabUrl(itemTitle.toUpperCase());
    if (toastTabUrl) {
      window.open(toastTabUrl, '_blank');
    } else {
      // Fallback to main ordering page if specific item URL not found
      window.open(TOAST_TAB_BASE_URL, '_blank');
    }
  };

  return (
    <div className="w-full h-full flex items-center justify-center py-8">
      <div className="grid grid-cols-2 gap-6 lg:gap-8 max-w-[600px]">
        {items.slice(0, 4).map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ scale: 1.03, y: -5, boxShadow: "0 25px 50px rgba(172, 148, 48, 0.4)" }}
            whileTap={{ scale: 0.98 }}
            onClick={() => handleOrderClick(item.title)}
            className="cursor-pointer min-h-[180px] lg:min-h-[220px] min-w-[140px] lg:min-w-[240px] drop-shadow-2xl p-6 lg:p-8 bg-gradient-to-br from-white/95 via-white to-[#fef9e7]/50 backdrop-blur-lg rounded-3xl flex flex-col items-center justify-center border border-[#ac9430]/30 hover:border-[#ac9430]/60 transition-all duration-300 relative overflow-hidden group"
          >
            {/* Decorative corner accent */}
            <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-br from-[#ac9430]/20 to-transparent rounded-bl-full" />
            <div className="absolute bottom-0 left-0 w-12 h-12 bg-gradient-to-tr from-[#227a32]/10 to-transparent rounded-tr-full" />
            
            {/* Content */}
            <div className="relative z-10 flex flex-col items-center">
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: index * 0.15 + 0.3, type: "spring", stiffness: 200 }}
                className="w-3 h-3 rounded-full bg-gradient-to-r from-[#ac9430] to-[#227a32] mb-3"
              />
              
              <h3 className="text-lg lg:text-2xl font-bold bg-gradient-to-r from-[#ac9430] to-[#227a32] bg-clip-text text-transparent text-center mb-2">
                {item.title}
              </h3>
              
              <p className="text-xs lg:text-sm text-gray-600 font-medium text-center line-clamp-2 mb-4 px-2">
                {item.desc}
              </p>
              
              <motion.div 
                whileHover={{ scale: 1.05 }}
                className="px-5 py-2 rounded-full bg-gradient-to-r from-[#ac9430] via-[#b89d35] to-[#227a32] shadow-lg group-hover:shadow-xl transition-shadow"
              >
                <p className="text-white font-bold text-base lg:text-xl">
                  ${item.price}
                </p>
              </motion.div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default StaticsImages;
